import axios from "axios";

export const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });
api.interceptors.request.use((c) => {
  const t = localStorage.getItem("token");
  if (t) c.headers.Authorization = `Bearer ${t}`;
  return c;
});

export const fileUrl = (p, priv = false) => {
  if (!p) return "";
  if (p.startsWith("http")) return p;
  const path = p.replace(/^\/api\/files\//, "");
  const t = localStorage.getItem("token");
  return `${API}/files/${path}${priv && t ? `?auth=${t}` : ""}`;
};

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Ocurrió un error";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d?.msg || String(d);
};

export const fmtUsdt = (n) => Number(n || 0).toFixed(2);
export const fmtCup = (n) => Math.round(Number(n || 0)).toLocaleString("es-ES");
export const fmtDate = (iso) => (iso ? new Date(iso).toLocaleString("es-ES", { dateStyle: "short", timeStyle: "short" }) : "");
export const shortId = (id) => (id ? `#${id.slice(0, 6).toUpperCase()}` : "");

export const STATUS_ES = {
  pending: "Pendiente", accepted: "Aceptado", assigned: "Chofer asignado", in_transit: "En camino",
  completed: "Entregado", cancelled: "Cancelado", disputed: "En disputa", pending_payment: "Esperando pago",
  paid: "Pagado", approved: "Aprobado", rejected: "Rechazado", active: "Activa", closed: "Cerrada",
  filled: "Completada", none: "Sin solicitar", sold: "Agotado", requested: "Solicitado", quoted: "Precio propuesto", in_progress: "En viaje",
};

export const STATUS_COLOR = {
  pending: "bg-amber-500/15 text-amber-300", accepted: "bg-cyan-500/15 text-cyan-300", assigned: "bg-sky-500/15 text-sky-300",
  in_transit: "bg-violet-500/15 text-violet-300", completed: "bg-emerald-500/15 text-emerald-300", cancelled: "bg-rose-500/15 text-rose-300",
  disputed: "bg-rose-500/20 text-rose-200", pending_payment: "bg-amber-500/15 text-amber-300", paid: "bg-cyan-500/15 text-cyan-300",
  approved: "bg-emerald-500/15 text-emerald-300", rejected: "bg-rose-500/15 text-rose-300", active: "bg-emerald-500/15 text-emerald-300",
  closed: "bg-slate-500/20 text-slate-300", filled: "bg-cyan-500/15 text-cyan-300", none: "bg-slate-500/20 text-slate-300", sold: "bg-slate-500/20 text-slate-300",
  requested: "bg-amber-500/15 text-amber-300", quoted: "bg-cyan-500/15 text-cyan-300", in_progress: "bg-violet-500/15 text-violet-300",
};

export const TX_ES = {
  deposit: "Recarga", hold: "Retención", unhold: "Liberación", sale: "Venta", delivery_fee: "Pago de entrega",
  p2p_buy: "Compra P2P", transfer_in: "Transferencia recibida", transfer_out: "Transferencia enviada",
  admin_adjust: "Ajuste admin", withdrawal: "Retiro", swap_out: "Canje (enviado)", swap_in: "Canje (recibido)", ride_pay: "Viaje Uber",
  game_buyin: "Entrada a mesa", game_cashout: "Retiro de mesa", referral_bonus: "Premio referido", subscription: "Suscripción",
};
export const RIDE_ES = { requested: "Solicitado", quoted: "Precio propuesto", accepted: "Aceptado", in_progress: "En viaje", completed: "Completado", cancelled: "Cancelado" };
export const fmtMoney = (n, cur = "USDT") => (cur === "CUP" ? `${fmtCup(n)} CUP` : `${fmtUsdt(n)} USDT`);
